
import { useRealDate } from '@src/hooks/useRealDate';

const defaultYear = 2025;

export function DisplayYear() {
  const { year, isLoading, error } = useRealDate();

  if (isLoading) {
    return <>{defaultYear}</>;
  }

  if (error) {
    return <>{year}</>;
  }

  return (
    <>{year}</>
  );
}
